import axios from "axios";

import apiRoutes from "../../constants/api-routes";

export const validateGroupId = (id) => {
	if (isNaN(id)) {
		return false;
	}

	return Number(id) > 0 && Number.isInteger(Number(id));
};

export const createGroupExistenceChecker = (authHeader) => {
	return async (id) => {
		try {
			const response = await axios.get(apiRoutes.getGroupById(id), { headers: authHeader });
			return !!response.data && !response.data.error;
		} catch (error) {
			console.error("Group not found:", error);
			return false;
		}
	};
};

const groupValidation = {
	validateGroupId,
	createGroupExistenceChecker
};

export default groupValidation;